import React, { useContext } from "react";
import { Card, Label, Segment } from "semantic-ui-react";
import formatDistance from "date-fns/formatDistance";
import { reportContext } from "contexts/ReportContext";

function ReportListItem({ record, ...rest }) {
	const { type } = useContext(reportContext);

	const getMessageBody = (record) => {
		if (type === "purchase")
			return `${record.quantity} units bought from ${record.supplier.name} at Rs.${record.rate} each.`;
		else if (type === "sales")
			return `${record.buyer} bought ${record.quantity} units at Rs.${record.rate} each.`;
		else if (type === "salesreturn")
			return `${record.buyer} returned ${record.quantity} unit(s).`;
		else if (type === "purchasereturn")
			return `${record.quantity} unit(s) returned to ${record.supplier.name}.`;
		else return "'Details could not be processed.'";
	};

	return (
		<Card
			{...rest}
			style={{
				padding: "20px",
				paddingBottom: "60px",
				position: "relative",
			}}
		>
			<Card.Header as="h4" style={{ marginBottom: "0px" }}>
				{record.productId.name}
			</Card.Header>
			<Card.Meta>
				{formatDistance(new Date(record.date), Date.now()) + " ago"}
			</Card.Meta>
			<Card.Description style={{ marginTop: "10px" }}>
				{getMessageBody(record)}
			</Card.Description>
			<Segment
				basic
				style={{ padding: "0px", position: "absolute", bottom: "10px" }}
			>
				<Label
					content={record.state.toUpperCase()}
					icon="dollar"
					color={record.state === "cash" ? "green" : "red"}
				/>
			</Segment>
		</Card>
	);
}

export default ReportListItem;
